/**
    200 means “authentication okay”, so now you can redirect to some other page.  For now, let’s just make it a page/view that reads “Successful login”.  This will set a cookie on the browser that allows subsequent requests to be authenticated automatically.
    401 means “bad username/password”
    409 means “Maximum number of concurrent administrator sessions are still in use”
*/
// function getMessage(code: number): string {
//     return i18n.t(code.toString()) || i18n.t('error.net')
// }

import api from 'api';
import ApiService from 'api/ApiService';
import {dispatchAsync} from 'redux/common';
import {action} from 'redux/helpers';
import types from './types';

// const processError = async (e: any, dispatch: ThunkDispatch<{}, {}, AnyAction>) => {
//     await dispatch(pushErrorToast(e._statusText || i18n.t(e.statusText)));
// }

const fetchItemsPermissions = (key: string) =>
   dispatchAsync(api.effectivepermissions + '/' + key, types.FETCH_ITEMS_PERMISSIONS, {
      getMethod: ApiService.getSecureJson,
      data: key,
      useReqDataOnSuccess: true,
      hideErrorToast: true,
      onError(error, dispatch?, eResponse?) {
         console.debug('perm error', error, eResponse);
         if (eResponse && eResponse.status !== 404) {
            dispatch?.(clearPermissionsEntry(key));
         }
      },
   });
const clearPermissionsEntry = (key: string) => action(types.CLEAR_PERMISSIONS_ENTRY, key);

export default {
   logout: action(types.LOGOUT.SAGA),
   fetchItemsPermissions,
   clearPermissionsEntry,
};
